import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { JupiterInspectionInfo } from '../../types/jupiter-inspection-info.type';

@Component({
  selector: 'app-lot-moto-jupiter-inspection-card',
  templateUrl: './lot-moto-jupiter-inspection-card.component.html',
  styleUrls: ['./lot-moto-jupiter-inspection-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotMotoJupiterInspectionCardComponent {
  @Input() inspectionInfo: JupiterInspectionInfo;
  @Output() noData = new EventEmitter<JupiterInspectionInfo>();

  hasImages = true;
  hasData = true;

  get hasNotes(): boolean {
    return !!Object.keys(this.inspectionInfo.notes).length;
  }

  noImages(): void {
    this.hasImages = false;
    this.hasData = this.hasNotes;

    if (!this.hasData) {
      this.noData.emit(this.inspectionInfo);
    }
  }
}
